import React from 'react';
import { propEq, find } from 'ramda';
import { transactionSummariesShape, totalNumberOfTransactionsShape } from 'constants/propTypes';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import currencySymbols from 'constants/currencies';
import { Row } from 'components/shared/Layout';
import { paymentMethods } from './paymentMethods';
import { StyledTable, StyledRow, StyledPaymentType, StyledCell } from './TransactionSummary.styles';

const TransactionSummary = ({ transactionSummaries, totalNumberOfTransactions: { EUR, GBP, USD } }) => (
  <StyledTable data-cy="transaction-summary">
    <Row columns={4} marginBottom="0">
      <StyledPaymentType bg="none" alignItems="center" justifyContent="center" start={2} span={1}>
        {currencySymbols.GBP} - <FormattedMessage id="shifts.pounds" />
      </StyledPaymentType>
      <StyledPaymentType bg="none" alignItems="center" justifyContent="center" span={1}>
        {currencySymbols.EUR} - <FormattedMessage id="shifts.euros" />
      </StyledPaymentType>
      <StyledPaymentType bg="none" alignItems="center" justifyContent="center" span={1}>
        {currencySymbols.USD} - <FormattedMessage id="shifts.dollars" />
      </StyledPaymentType>
    </Row>

    <StyledRow columns={4} marginBottom="0" data-id="number-transactions">
      <StyledPaymentType bg="none" span={1} justifyContent="flex-end">
        <FormattedMessage id="shifts.noOfTransactions" />
      </StyledPaymentType>
      <StyledCell justifyContent="center" span={1}>
        {GBP}
      </StyledCell>
      <StyledCell justifyContent="center" span={1}>
        {EUR}
      </StyledCell>
      <StyledCell justifyContent="center" span={1}>
        {USD}
      </StyledCell>
    </StyledRow>

    {Object.entries(paymentMethods).map(([method, label]) => {
      const transaction = find(propEq('type', method), transactionSummaries) || {};

      return (
        <StyledRow columns={4} marginBottom="0" data-id={`payment-summary-${method}`} key={label}>
          <StyledPaymentType alignItems="center" justifyContent="flex-end" span={1}>
            <FormattedMessage id={label} />
          </StyledPaymentType>
          <StyledCell justifyContent="center" span={1} data-id="total-in-pounds">
            {Number(transaction.totalAmountInPounds) ? <FormattedCurrency amount={transaction.totalAmountInPounds} currency="GBP" /> : '-'}
          </StyledCell>
          <StyledCell justifyContent="center" span={1} data-id="total-in-euros">
            {Number(transaction.totalAmountInEuros) ? <FormattedCurrency amount={transaction.totalAmountInEuros} currency="EUR" /> : '-'}
          </StyledCell>
          <StyledCell justifyContent="center" span={1} data-id="total-in-dollars">
            {Number(transaction.totalAmountInDollars) ? (
              <FormattedCurrency amount={transaction.totalAmountInDollars} currency="USD" />
            ) : (
              '-'
            )}
          </StyledCell>
        </StyledRow>
      );
    })}
  </StyledTable>
);

TransactionSummary.propTypes = {
  transactionSummaries: transactionSummariesShape,
  totalNumberOfTransactions: totalNumberOfTransactionsShape
};

export default TransactionSummary;
